<div class="footer-holder flex justify-content-between align-items-center">
  <ng-content select="[card-left]"/>
  <ng-content select="[card-right]" />
</div>
